export const myAssetsData = [
  {
    id: "AT-001",
    brand: "Dell",
    model: "Latitude 5440",
    assetType: "Laptop",
    assetIdModel: "DL45862",
    serialNumber: "0002223344",
    assignedDate: "12 Jan 2025",
    status: "Assigned",
    requestDate: "09 Jan 2025",
    assignedTo: "Pavan Kumar",
    role: "Developer",
    condition: "Good",
    remarks: "Issued at the time of project allocation"
  },
  {
    id: "AT-002",
    brand: "LG",
    model: '24" Monitor',
    assetType: "Monitor",
    assetIdModel: "LG45862",
    serialNumber: "0001223344",
    assignedDate: "12 Jan 2025",
    status: "Assigned",
    requestDate: "09 Jan 2025",
    assignedTo: "Pavan Kumar",
    role: "Developer",
    condition: "Good",
    remarks: "Dual monitor setup"
  },
  {
    id: "AT-003",
    brand: "LG",
    model: '24" Monitor',
    assetType: "Monitor",
    assetIdModel: "LG45862",
    serialNumber: "0112223344",
    assignedDate: "12 Jan 2025",
    status: "Assigned",
    requestDate: "09 Jan 2025",
    assignedTo: "Pavan Kumar",
    role: "Developer",
    condition: "Good",
    remarks: "Dual monitor setup"
  },
  {
    id: "AT-004",
    brand: "LG",
    model: '24" Monitor',
    assetType: "Monitor",
    assetIdModel: "LG45862",
    serialNumber: "0002223355",
    assignedDate: "12 Jan 2025",
    status: "Assigned",
    requestDate: "09 Jan 2025",
    assignedTo: "Pavan Kumar",
    role: "Developer",
    condition: "Good",
    remarks: "Replacement monitor"
  },
];

export const assetTransferData = [
  {
    requestId: "TR-001",
    assetInfo: {
      name: "Dell Latitude 5440",
      type: "Laptop",
      model: "DL45862"
    },
    currentOwner: {
      name: "Pavan Kumar",
      role: "Front-end Developer"
    },
    type: "Transferred",
    transferTo: {
      name: "Ramesh Raj",
      role: "Front-end Developer"
    },
    requestDate: "18 Jul 2025",
    status: "Pending HR Approval"
  },
  {
    requestId: "TR-002",
    assetInfo: {
      name: 'LG 24" Monitor',
      type: "Monitor",
      model: "LG45862"
    },
    currentOwner: {
      name: "Pavan Kumar",
      role: "Front-end Developer"
    },
    type: "Transferred",
    transferTo: {
      name: "Rahul Varma",
      role: "Engineering"
    },
    requestDate: "17 Jul 2025",
    status: "Waiting for Receiver"
  },
  {
    requestId: "RT-003",
    assetInfo: {
      name: 'LG 24" Monitor',
      type: "Monitor",
      model: "LG45862"
    },
    currentOwner: {
      name: "Pavan Kumar",
      role: "Front-end Developer"
    },
    type: "Returned",
    transferTo: {
      name: "Company",
      role: ""
    },
    requestDate: "15 Jul 2025",
    status: "Returned"
  },
  {
    requestId: "TR-004",
    assetInfo: {
      name: 'LG 24" Monitor',
      type: "Monitor",
      model: "LG45862"
    },
    currentOwner: {
      name: "Pavan Kumar",
      role: "Front-end Developer"
    },
    type: "Transferred",
    transferTo: {
      name: "Akhil Rao",
      role: "Engineering"
    },
    requestDate: "11 Jul 2025",
    status: "Transferred"
  }
];

export const allAssetRequestsData = [
  {
    requestId: "AT-001",
    assetInfo: {
      name: "Dell Latitude 5440",
      type: "Laptop",
      model: "DL45862"
    },
    employeeFrom: {
      name: "Pavan Kumar",
      role: "UI Designer"
    },
    type: "Transfer",
    requestDate: "18 Jul 2025",
    status: "Pending HR Approval"
  },
  {
    requestId: "AT-002",
    assetInfo: {
      name: 'LG 24" Monitor',
      type: "Monitor",
      model: "LG45862"
    },
    employeeFrom: {
      name: "Arun Kumar",
      role: "Front-end Developer"
    },
    type: "Transfer",
    requestDate: "17 Jul 2025",
    status: "Waiting for Receiver"
  },
  {
    requestId: "AT-003",
    assetInfo: {
      name: 'LG 24" Monitor',
      type: "Monitor",
      model: "LG45862"
    },
    employeeFrom: {
      name: "Jai Veer",
      role: "Back-end Developer"
    },
    type: "Transfer",
    requestDate: "15 Jul 2025",
    status: "Completed"
  },
  {
    requestId: "AT-004",
    assetInfo: {
      name: 'LG 24" Monitor',
      type: "Monitor",
      model: "LG45862"
    },
    employeeFrom: {
      name: "Subhash",
      role: "Front-end Developer"
    },
    type: "Transfer",
    requestDate: "11 Jul 2025",
    status: "Rejected"
  }
];
